import sortBy from 'lodash/sortBy';

import {
  ActivitiesComponentType,
  ACTIVITIES_COMPONENT_TYPE_ACTIVITY,
  ACTIVITIES_COMPONENT_TYPE_TABLE,
  COMPONENT_TEMPLATE_TABLE_TEXT_ID,
  COMPONENT_TEMPLATE_CLASS_DISCUSSION_ACTIVITY_ID,
} from 'global/constants';
import type { GetComponentTemplatesQuery } from '../../lesson-builder.graphql.generated';
import {
  AddComponentTemplate,
  MenuCategory,
  MenuData,
} from './components-menu.constants';
import type { StimulusResourceFragment } from '../../../shared/stimulus/stimulus.graphql.generated';
import type { Pluck } from 'lib/gql/pluck';

export function buildComponentMenu(
  templates: (Pluck<
    GetComponentTemplatesQuery,
    'getComponentTemplates'
  > | null)[],
  onSelect: (values: AddComponentTemplate) => void,
  componentFilter?: ActivitiesComponentType[]
) {
  const menuItems: MenuData[] = [
    {
      section: MenuCategory.Activity,
      label: 'Questions',
      items: [],
    },
    {
      section: MenuCategory.Text,
      label: 'Text',
      items: [],
    },
    {
      section: MenuCategory.Image,
      label: 'Image',
      items: [],
    },
    {
      section: MenuCategory.Stimulus,
      label: 'Stimulus',
      items: [],
    },
    {
      section: MenuCategory.Columns,
      label: 'Columns',
      items: [],
    },
  ];

  let sortedTemplates = sortBy(templates, 'sort');
  if (componentFilter) {
    sortedTemplates = sortedTemplates.filter(
      t =>
        componentFilter &&
        componentFilter.includes(t?.data.optimisticResponse.type)
    );
  }
  sortedTemplates.forEach(template => {
    const menu = menuItems.find(
      mi => mi.section.toLowerCase() === template?.group
    );
    if (template && menu) {
      const isSubActivity =
        template.group === ACTIVITIES_COMPONENT_TYPE_ACTIVITY ||
        template.data.componentProperties.type ===
          ACTIVITIES_COMPONENT_TYPE_TABLE;
      const payload: AddComponentTemplate = {
        templateId: template.id,
        optimisticComponent: template.data.optimisticResponse,
        isSubActivity,
        defaultSubActivityData: isSubActivity
          ? {
              areInstructionsVisible:
                template.id !== COMPONENT_TEMPLATE_TABLE_TEXT_ID &&
                template.id !== COMPONENT_TEMPLATE_CLASS_DISCUSSION_ACTIVITY_ID,
            }
          : undefined,
        componentData: undefined,
      };

      menu.items.push({
        ...template,
        getPayload: () => payload,
        onClick: (stimulus?: StimulusResourceFragment) =>
          onSelect({ ...payload, stimulus }),
      });
    }
  });
  return menuItems.filter(m => m.items.length > 0);
}
